export default {
    mvpIntro: 'MVP của buổi học này là ~',
    buttons: {
        show: 'Xem',
    },
};
